<template>
  <div class="mc-liveview--fo-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div v-b-toggle.accordion-1 class="d-flex justify-content-between">
        <h5>Informasi Penugasan</h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>
    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
      <div class="mc-liveview--fo-sidebar-driver">
        <b-row>
          <b-col md="6">
            <span class="text-muted">Plat Nomor</span>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton />
              </template>
              <p>
                {{ dataDriver.vehicle.license_plate }}
                <McBadge
                  v-if="dataDriver.vehicle.hull_no"
                  :text="dataDriver.vehicle.hull_no"
                  variant="outlinePlainSecondary"
                  size="medium"
                  type="button"
                />
              </p>
            </b-skeleton-wrapper>
          </b-col>
          <b-col v-if="referenceNumber != null && referenceNumber !== ''" md="6">
            <span class="text-muted">Referensi Penugasan</span>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton />
              </template>
              <p>{{ referenceNumber }}</p>
            </b-skeleton-wrapper>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <span class="text-muted">Pengemudi Utama</span>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton />
              </template>
              <p>
                {{ dataDriver.driver?.name ?? '-' }}
                <i v-if="dataDriver.driver?.phone_number" class="text-muted">
                  ({{ dataDriver.driver?.phone_number }})
                </i>
              </p>
            </b-skeleton-wrapper>
          </b-col>
          <b-col md="6">
            <span class="text-muted">Pengemudi Tambahan</span>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton />
              </template>
              <p>
                {{ dataDriver.driver_2?.name ?? '-' }}
                <i v-if="dataDriver.driver_2?.phone_number" class="text-muted">
                  ({{ dataDriver.driver_2?.phone_number }})
                </i>
              </p>
            </b-skeleton-wrapper>
          </b-col>
        </b-row>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import McBadge from '@/components/McBadge'

export default {
  components: {
    McBadge,
  },
  props: {
    dataDriver: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    referenceNumber: {
      type: String,
      default: '-',
    },
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isLoading() {
      return this.loading
    },
  },
}
</script>
